import React, { Component } from 'react'

class menu extends Component {
    render() {
        // var homeUrl = "/?orgId=" + this.props.fDataItems.ORG_ID + "&coordinator=" + this.props.fDataItems.COORDINATOR + "&cogId=" + this.props.fDataItems.COGNITO_ID;
        //var RequestUrl = "/rDetails/?orgId=" + this.props.fDataItems.ORG_ID + "&coordinator=" + this.props.fDataItems.COORDINATOR + "&cogId=" + this.props.fDataItems.COGNITO_ID;
        return (
            <div className="cb-local-navigation sticky">
                <nav className="cb-desktop-navigation">
                    <div className="container">
                    <div className="row">
                    <div className="col-xs-12">
                        <div className="cb-site-name">
                            <a className="title cb-program-name" href="/">AP Test Center Enrollment</a>
                        </div>
                        <ul className="cb-local-menu navigation">
                            <li className=" "><a href="/"><span className="cb-glyph cb-home"></span>Home</a></li>
                            {/* <li className=" "><a href="/rDetails"> Request Details</a></li> */}
                           </ul>
                           </div></div>
                    </div></nav>
            </div>
        )
    }
}
export default menu
